// extracted by mini-css-extract-plugin
export default {"icon":"UserAvatar_icon__VmZcL","popover":"UserAvatar_popover__b6vAZ","teacher":"UserAvatar_teacher__L8vLj"};